import axios, { AxiosError } from "axios";
// import { useRefreshTokenHandler } from "hooks/useAxios"
import storage from "utils/storage";

export const restfulRequest = () => {
  // const refreshTokenHandler = useRefreshTokenHandler()
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL_LOGIN,
    headers: { "Content-Type": "application/json", Accept: "application/json" },
  });
  axiosInstance.interceptors.request.use(
    async (config) => {
      if (!config?.headers) {
        throw new Error(
          `Expected 'config' and 'config.headers' not to be undefined`
        );
      }
      const token = storage.getToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      // const config = error.config as unknown as InternalAxiosRequestConfig
      if (error.response?.status === 401 || error.response?.status === 403) {
        // NOTE: when token is updating, return API connection queue
        // if (refreshTokenHandler) {
        //   axiosInstance(config)
        // }
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
